import Cases from '@/pages/Cases';

export default function MobileCases() {
  return <Cases />;
}

